
import EDCaptionedValue from '../../../../../../../BaseComponents/CaptionedValue/EDCaptionedValue';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest } from '../../Queries/_QueryTypes/FakturaDelQuery';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { TEDLRFakturaDelATTEST_STATUSEnum } from '../../../../../../../globalQueryTypes';

interface IProps {
  rubrik: string;
  attestantLista: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest[];
  disabled: boolean;
  fakturadelStatus: TEDLRFakturaDelATTEST_STATUSEnum | null;
  allaBeslutAttestanterHarAtttesterat: boolean;
}

const isAttesteradByReserv = (
  attestant: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest
): boolean => {
  if (attestant.RESERV_ID && attestant.RESERV_LOPNR && attestant.Reserv) {
    return true;
  }
  return false;
};

const removeReservTitle = (reservTitle: string | null): string => {
  if (reservTitle) {
    const result = reservTitle?.split('-');
    return result[0].trim();
  } else {
    return '';
  }
};

const statusText = (
  attestant: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest,
  fakturadelStatus: TEDLRFakturaDelATTEST_STATUSEnum | null,
  rubrik: string,
  allaBeslutAttestanterHarAtttesterat: boolean
): string => {
  let result: string = '';

  if (attestant.STATUS === 'ATTESTERAD') {
    result = ' (Attesterad ' + attestant.STATUS_DATUM;
    if (isAttesteradByReserv(attestant)) {
      const reservName = removeReservTitle(attestant.Reserv);
      result += ' av reserv ' + reservName + ')';
    } else {
      result += ')';
    }
  } else {
    if (
      fakturadelStatus !== TEDLRFakturaDelATTEST_STATUSEnum.UNDER_UTREDNING &&
      attestant.STATUS === 'UTDELAD' &&
      (rubrik !== 'Beslutsattest' ||
        fakturadelStatus !==
          TEDLRFakturaDelATTEST_STATUSEnum.MOTTAGNINGSATTESTERAS)
    ) {
      if (rubrik === 'Kontrollattest' && !allaBeslutAttestanterHarAtttesterat) {
        result = '';
      } else {
        result = ' (Utdelad)';
      }
    } else {
      result = '';
    }
  }

  return result;
};

const useStyles = makeStyles()((theme: Theme) => {
  return {
    textDisabledColor: { color: theme.palette.action.disabled },
  };
});

const getReserverToAttestant = (reservLista: any): string => {
  let result = '';

  if (!reservLista || reservLista?.length === 0) {
    return result;
  }

  if (reservLista.length === 1) {
    result = '(Reserv: ';
  } else {
    result = '(Reserver: ';
  }

  for (let index = 0; index < reservLista.length; index++) {
    const reserv = reservLista[index];
    if (index === 0) {
      result += reserv?._Associations.Reserv._Associations?.Attestant.BENAMNING;
    } else {
      result +=
        ', ' + reserv?._Associations.Reserv._Associations?.Attestant.BENAMNING;
    }
  }

  return result + ')';
};

/** Lista av attestanter av en viss typ t.ex. mottagningsattestanterna på en fakturadel */
const AttestantTyp: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { classes } = useStyles();

  return (
    <EDCaptionedValue
      label={props.rubrik}
      name={`AttestantTyp-${props.rubrik}`}
      size="ownblock"
      disabled={props.disabled}
      testId={`AttestantTyp-${props.rubrik}`}
    >
      <EDTypography
        className={props.disabled ? classes.textDisabledColor : ''}
        variant="body1"
      >
        {props.attestantLista
          .map((attestant: any) => {
            const reservText =
              attestant.STATUS === 'ATTESTERAD'
                ? ''
                : attestant._Associations?.Attestratt?._Associations
                    ?.Reserver == undefined
                ? getReserverToAttestant(
                    attestant._Associations?.Attestratt?._Associations
                      ?.Reserver_All
                  )
                : getReserverToAttestant(
                    attestant._Associations?.Attestratt?._Associations?.Reserver
                  );

            return `${attestant.Attestant}
            ${statusText(
              attestant,
              props.fakturadelStatus,
              props.rubrik,
              props.allaBeslutAttestanterHarAtttesterat
            )} ${reservText}`;
          })
          .join(', ')}
      </EDTypography>
    </EDCaptionedValue>
  );
};

export default AttestantTyp;
